export default [
  {
    name:'Pending',
    value:'pending',
  },
  {
    name:'Sent',
    value:'sent',
  },
]